module.exports = __webpack_public_path__ + "img/zeit.08ba60f2.svg";